import SlickCarousel from './SlickCarousel';

const Carousel3 = (props) => {
  const categoria = props.data.categoria;
  return (
    <div className='container mb-8 md:mb-12 carouselx3'>
      <h3 className='feauteredSevenTwenty-title text-gray-600 mb-3'>{categoria.descripcion}</h3>
      <SlickCarousel itemsPerPage={3} {...props} />
    </div>
  );
};

export default Carousel3;
